import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    dir: 'ltr',
    nav: {
      home: 'Home',
      products: 'Products',
      product: 'Cream',
      facewash: 'Face Wash',
      ingredients: 'Ingredients',
      order: 'Order Now',
    },
    hero: {
      tag: 'New Formula · Ceramide Complex',
      brand: 'MISKY',
      tagline: 'Ceramide Complex 2%',
      subtitle: 'Face & Body — Daily Skin Care',
      description:
        'Enjoy soft, hydrated skin all day long with our lightweight moisturizer enriched with Ceramide NP & NG and Aloe Vera Extract. It helps nourish and hydrate the skin while maintaining its softness and natural radiance, without leaving any greasy feel or excess shine.',
      badges: ['Lightweight', 'Daily Protection', 'Gentle on Skin', 'Suitable for Daily Use'],
      price: '12',
      currency: 'JD',
      capacity: '150 ml · Face & Body',
      cta: 'Order Now',
      learnMore: 'Learn More',
      ceramide: 'Ceramide NP + NG',
      barrierRepair: 'Barrier repair',
      dailyFormula: 'Daily Formula',
    },
    product: {
      sectionLabel: 'The Product',
      title: 'Face & Body Cream',
      faceBody: 'FACE & BODY',
      dailySkin: 'DAILY SKIN CARE',
      howToUse: 'How to Use',
      warningsLabel: 'Warnings',
      externalOnly: 'For external use only · 150 ml',
      warnings: [
        'Store below 30°C, away from sunlight.',
        'Keep out of reach of children.',
        'Avoid contact with the eyes.',
        'If irritation occurs, stop use immediately.',
      ],
      steps: [
        { icon: '💧', text: 'Apply an appropriate amount on clean, dry skin.' },
        { icon: '🔄', text: 'Gently spread on face and neck with circular motions.' },
        { icon: '☀️', text: 'Use morning and evening for best results.' },
        { icon: '📅', text: 'Daily use gives your skin a healthy, balanced look.' },
      ],
    },
    ingredients: {
      sectionLabel: "What's Inside",
      title: 'Key Ingredients',
      showFull: 'Show full list ↓',
      showLess: 'Show less ↑',
      fullListLabel: 'Full Ingredients List',
      items: [
        { icon: '🔬', name: 'Ceramide Complex 2%', desc: 'Restores the skin barrier and locks in moisture all day.' },
        { icon: '🌿', name: 'Aloe Vera Extract', desc: 'Soothes, calms and deeply hydrates the skin.' },
        { icon: '🧴', name: 'Shea Butter', desc: 'Rich nourishment for soft, supple skin.' },
        { icon: '🌰', name: 'Sweet Almond Oil', desc: 'Lightweight oil that conditions without greasiness.' },
      ],
    },
    productsOverview: {
      sectionLabel: 'Our Products',
      title: 'The MISKY Collection',
      viewDetails: 'View Details',
      orderNow: 'Order Now',
    },
    facewash: {
      sectionLabel: 'Face Wash',
      title: 'Tea Tree & Chamomile Face Wash',
      subtitle: 'GENTLE DAILY CLEANSER',
      howToUse: 'How to Use',
      warningsLabel: 'Warnings',
      externalOnly: 'For external use only · 160 ml',
      ingredientsLabel: "What's Inside",
      keyIngredients: 'Key Ingredients',
      showFull: 'Show full list ↓',
      showLess: 'Show less ↑',
      fullListLabel: 'Full Ingredients List',
      warnings: [
        'Store below 30°C, away from sunlight.',
        'Keep out of reach of children.',
        'Avoid contact with the eyes.',
        'If irritation occurs, stop use immediately.',
      ],
      steps: [
        { icon: '💦', text: 'Wet your face with water.' },
        { icon: '🤲', text: 'Apply an appropriate amount and gently massage into skin.' },
        { icon: '🚿', text: 'Rinse face thoroughly with water.' },
        { icon: '🌿', text: 'Pat dry gently. Use morning and evening or as needed.' },
      ],
      keyItems: [
        { icon: '🌱', name: 'Tea Tree Oil', desc: 'Natural antibacterial that helps control blemishes and purify skin.' },
        { icon: '🌼', name: 'Chamomile Extract', desc: 'Soothes and calms irritated or sensitive skin.' },
        { icon: '🌿', name: 'Aloe Vera Extract', desc: 'Hydrates and refreshes skin after cleansing.' },
        { icon: '🔬', name: 'Salicylic Acid', desc: 'Gently exfoliates and helps unclog pores.' },
      ],
    },
    order: {
      sectionLabel: 'Place Your Order',
      title: 'Order Now',
      selectProduct: 'Select Product',
      productName: 'MISKY Face & Body Cream',
      productSub: 'Ceramide Complex 2% · 150 ml',
      quantityLabel: 'Quantity',
      total: 'Total',
      namePlaceholder: 'Your name (optional)...',
      notePlaceholder: 'Any notes...',
      noteLabel: 'Note',
      nameLabel: 'Your Name (optional)',
      whatsappBtn: 'Send Order via WhatsApp',
      contactTitle: 'Contact Us',
      noteBox: "We process orders via WhatsApp for the fastest response. Simply tap the button, review your order message, and send!",
      whatsappMsg: (items) => {
        const { name, note, qty, total } = items;
        let msg = `Hello Misky! 👋\n\nI'd like to order:\n\n`;
        msg += `📦 *MISKY Face & Body Cream*\n`;
        msg += `   Ceramide Complex 2% · 150 ml\n`;
        msg += `   Qty: ${qty}\n`;
        msg += `   Price: 12 JD × ${qty} = *${total} JD*\n`;
        if (name) msg += `\n👤 Name: ${name}`;
        if (note) msg += `\n📝 Note: ${note}`;
        msg += `\n\nPlease confirm my order. Thank you! ✨`;
        return msg;
      },
    },
    footer: {
      rights: '© 2025 Misky. All rights reserved.',
      location: 'Jordan / Amman / Khalda',
      orderWhatsapp: 'Order on WhatsApp',
      exclusive: 'An exclusive product of Fadel Al-Sous E-Commerce Foundation',
      poweredBy: 'Powered by',
    },
    contact: {
      whatsapp: 'WhatsApp',
      phone: 'Phone',
      email: 'Email',
      location: 'Location',
    },
  },

  ar: {
    dir: 'rtl',
    nav: {
      home: 'الرئيسية',
      products: 'منتجاتنا',
      product: 'الكريم',
      facewash: 'غسول الوجه',
      ingredients: 'المكونات',
      order: 'اطلب الآن',
    },
    hero: {
      tag: 'تركيبة جديدة · مركب السيراميد',
      brand: 'MISKY',
      tagline: 'مركب السيراميد 2%',
      subtitle: 'للوجه والجسم — عناية يومية',
      description:
        'استمتعي ببشرة رطبة ناعمة طوال اليوم مع مرطبنا الخفيف الغني بمركب السيراميد NP وNG وخلاصة الألوفيرا. يساعد على تغذية البشرة وترطيبها مع الحفاظ على نعومتها وإشراقتها الطبيعية دون أي ملمس دهني أو لمعان زائد.',
      badges: ['ملمس خفيف', 'حماية يومية', 'لطيف على البشرة', 'مناسب للاستخدام اليومي'],
      price: '12',
      currency: 'دينار',
      capacity: '150 مل · للوجه والجسم',
      cta: 'اطلب الآن',
      learnMore: 'اعرف المزيد',
      ceramide: 'سيراميد NP + NG',
      barrierRepair: 'ترميم حاجز البشرة',
      dailyFormula: 'تركيبة يومية',
    },
    product: {
      sectionLabel: 'المنتج',
      title: 'كريم للوجه والجسم',
      faceBody: 'للوجه والجسم',
      dailySkin: 'عناية يومية بالبشرة',
      howToUse: 'إرشادات الاستخدام',
      warningsLabel: 'التحذيرات',
      externalOnly: 'مخصص للاستخدام الخارجي فقط · 150 مل',
      warnings: [
        'يُحفظ في درجة حرارة أقل من 30 درجة مئوية بعيداً عن أشعة الشمس.',
        'يحفظ بعيداً عن متناول الأطفال.',
        'لا يستخدم على العين.',
        'في حال التهيج وقف الاستخدام فوراً.',
      ],
      steps: [
        { icon: '💧', text: 'ضعي كمية مناسبة من الكريم على بشرة نظيفة وجافة.' },
        { icon: '🔄', text: 'وزعي الكريم بلطف على الوجه والرقبة بحركات دائرية.' },
        { icon: '☀️', text: 'يُستخدم صباحاً ومساءً للحصول على أفضل النتائج.' },
        { icon: '📅', text: 'المواظبة اليومية تمنح بشرتك مظهراً صحياً ومتوازناً.' },
      ],
    },
    ingredients: {
      sectionLabel: 'ما بداخله',
      title: 'المكونات الفعّالة',
      showFull: 'عرض القائمة الكاملة ↓',
      showLess: 'إخفاء ↑',
      fullListLabel: 'قائمة المكونات الكاملة',
      items: [
        { icon: '🔬', name: 'مركب السيراميد 2%', desc: 'يُعيد بناء حاجز البشرة ويحبس الرطوبة طوال اليوم.' },
        { icon: '🌿', name: 'خلاصة الألوفيرا', desc: 'تهدئ البشرة وتروّيها وترطبها بعمق.' },
        { icon: '🧴', name: 'زبدة الشيا', desc: 'تغذية غنية للبشرة الناعمة والمرنة.' },
        { icon: '🌰', name: 'زيت اللوز الحلو', desc: 'زيت خفيف يعتني بالبشرة دون أي دهنية.' },
      ],
    },
    productsOverview: {
      sectionLabel: 'منتجاتنا',
      title: 'مجموعة مسكي',
      viewDetails: 'التفاصيل',
      orderNow: 'اطلب الآن',
    },
    facewash: {
      sectionLabel: 'غسول الوجه',
      title: 'غسول الوجه — شجرة الشاي والبابونج',
      subtitle: 'غسول لطيف للاستخدام اليومي',
      howToUse: 'إرشادات الاستخدام',
      warningsLabel: 'التحذيرات',
      externalOnly: 'مخصص للاستخدام الخارجي فقط · 160 مل',
      ingredientsLabel: 'ما بداخله',
      keyIngredients: 'المكونات الفعّالة',
      showFull: 'عرض القائمة الكاملة ↓',
      showLess: 'إخفاء ↑',
      fullListLabel: 'قائمة المكونات الكاملة',
      warnings: [
        'يُحفظ في درجة حرارة أقل من 30 درجة مئوية بعيداً عن أشعة الشمس.',
        'يحفظ بعيداً عن متناول الأطفال.',
        'لا يستخدم على العين.',
        'في حال التهيج وقف الاستخدام فوراً.',
      ],
      steps: [
        { icon: '💦', text: 'بللي الوجه بالماء.' },
        { icon: '🤲', text: 'ضعي كمية مناسبة من الغسول ودلّكي البشرة بلطف.' },
        { icon: '🚿', text: 'اشطفي الوجه جيداً بالماء.' },
        { icon: '🌿', text: 'جففي برفق واستخدمي صباحاً ومساءً أو حسب الحاجة.' },
      ],
      keyItems: [
        { icon: '🌱', name: 'زيت شجرة الشاي', desc: 'مضاد طبيعي للبكتيريا يساعد على التنقية ومكافحة الشوائب.' },
        { icon: '🌼', name: 'خلاصة البابونج', desc: 'تهدئ البشرة المتهيجة أو الحساسة وتريحها.' },
        { icon: '🌿', name: 'خلاصة الألوفيرا', desc: 'ترطب البشرة وتمنحها انتعاشاً بعد التنظيف.' },
        { icon: '🔬', name: 'حمض الساليسيليك', desc: 'يقشّر البشرة بلطف ويساعد على تنظيف المسام.' },
      ],
    },
    order: {
      sectionLabel: 'أرسل طلبك',
      title: 'اطلب الآن',
      selectProduct: 'اختر المنتج',
      productName: 'كريم مسكي للوجه والجسم',
      productSub: 'مركب السيراميد 2% · 150 مل',
      quantityLabel: 'الكمية',
      total: 'الإجمالي',
      namePlaceholder: 'اسمك (اختياري)...',
      notePlaceholder: 'أي ملاحظات إضافية...',
      noteLabel: 'ملاحظة',
      nameLabel: 'اسمك (اختياري)',
      whatsappBtn: 'أرسل طلبك عبر واتساب',
      contactTitle: 'تواصل معنا',
      noteBox: 'نستقبل الطلبات عبر واتساب لضمان أسرع استجابة. فقط اضغط الزر وستجد رسالة طلبك جاهزة — أرسلها مباشرة!',
      whatsappMsg: (items) => {
        const { name, note, qty, total } = items;
        let msg = `مرحباً Misky! 👋\n\nأود طلب المنتج التالي:\n\n`;
        msg += `📦 *كريم مسكي للوجه والجسم*\n`;
        msg += `   مركب السيراميد 2% · 150 مل\n`;
        msg += `   الكمية: ${qty}\n`;
        msg += `   السعر: 12 دينار × ${qty} = *${total} دينار*\n`;
        if (name) msg += `\n👤 الاسم: ${name}`;
        if (note) msg += `\n📝 ملاحظة: ${note}`;
        msg += `\n\nأرجو تأكيد الطلب، شكراً! ✨`;
        return msg;
      },
    },
    footer: {
      rights: '© 2025 مسكي. جميع الحقوق محفوظة.',
      location: 'الأردن / عمّان / خلدا',
      orderWhatsapp: 'اطلب عبر واتساب',
      exclusive: 'منتج خاص بمؤسسة فضل الصوص للتجارة الإلكترونية',
        poweredBy: 'Powered by',
    },
    contact: {
      whatsapp: 'واتساب',
      phone: 'الهاتف',
      email: 'البريد الإلكتروني',
      location: 'الموقع',
    },
  },
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('ar');
  const t = translations[lang];

  useEffect(() => {
    document.documentElement.dir = t.dir;
    document.documentElement.lang = lang;
  }, [lang, t.dir]);

  const toggle = () => setLang((l) => (l === 'en' ? 'ar' : 'en'));

  return (
    <LanguageContext.Provider value={{ lang, t, toggle }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
